import { useState } from "react";
import { Phone, MessageCircle, Globe, QrCode } from "lucide-react";

/**
 * Reusable real-size digital business card that flips on click to reveal a QR.
 * Purely presentational — used on the landing hero and (later) editor preview.
 */
export const FlipCard = ({
  name = "Tu Nombre",
  role = "Tu profesión o negocio",
  slogan = "Cada contacto suma",
  phone = "+52 55 1234 5678",
  primary = "#E25A38",
  dark = "#1C1917",
  qrData = "https://xuma.mx",
}) => {
  const [flipped, setFlipped] = useState(false);
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data=${encodeURIComponent(
    qrData
  )}`;

  return (
    <div className="perspective w-full max-w-[420px] aspect-[1.58/1] mx-auto select-none">
      <button
        type="button"
        onClick={() => setFlipped((f) => !f)}
        data-testid="flip-card-container"
        aria-label="Girar tarjeta"
        className={`flip-inner block w-full h-full text-left cursor-pointer rounded-2xl shadow-[0_30px_60px_-20px_rgba(28,25,23,0.45)] ${
          flipped ? "flipped" : ""
        }`}
      >
        {/* FRONT */}
        <div
          className="flip-face flip-front rounded-2xl p-7 flex flex-col justify-between"
          style={{ background: dark }}>
          <div className="flex items-start justify-between">
            <div>
              <div
                className="text-[10px] uppercase tracking-[0.3em] font-medium"
                style={{ color: primary }}
              >
                XUMA
              </div>
              <h3 className="text-white text-2xl font-heading font-extrabold mt-3 leading-none">
                {name}
              </h3>
              <p className="text-white/60 text-sm mt-1">{role}</p>
            </div>
            <span
              className="h-11 w-11 rounded-xl grid place-items-center shrink-0"
              style={{ background: primary }}
            >
              <QrCode className="h-5 w-5 text-white" />
            </span>
          </div>
          <div>
            <p className="text-white/90 text-sm italic mb-4">"{slogan}"</p>
            <div className="flex items-center gap-4 text-white/70 text-xs">
              <span className="flex items-center gap-1.5">
                <Phone className="h-3.5 w-3.5" /> {phone}
              </span>
              <span className="flex items-center gap-1.5">
                <MessageCircle className="h-3.5 w-3.5" style={{ color: primary }} /> WhatsApp
              </span>
            </div>
          </div>
          <span className="absolute bottom-3 right-4 text-white/30 text-[10px]">
            Toca para girar
          </span>
        </div>

        {/* BACK */}
        <div
          className="flip-face flip-back rounded-2xl p-7 flex items-center gap-6 bg-white"
          style={{ borderTop: `4px solid ${primary}` }}
        >
          <img
            src={qrUrl}
            alt="Código QR de la tarjeta"
            className="h-32 w-32 rounded-lg"
            loading="lazy"
          />
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-xuma-muted">Escanea</p>
            <h4 className="font-heading font-bold text-xuma-dark text-lg leading-tight mt-1">
              Comparte tu tarjeta
            </h4>
            <p className="text-sm text-xuma-muted mt-2 flex items-center gap-1.5">
              <Globe className="h-4 w-4" style={{ color: primary }} /> xuma.mx
            </p>
          </div>
        </div>
      </button>
    </div>
  );
};

export default FlipCard;
